import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { REST_BIOMETRIE_URL } from '../app.config';
import { ValueListItem } from '../models/rest/valuelist/valuelist';
import { UserSettingsService } from './usersettings.service';


@Injectable()
export class FingerabdruckService implements OnDestroy {
  private subscription: Subscription = new Subscription();

  fingerabdruckDevices: string[] = [];
  private lastUsedDevice?: string;

  constructor(private http: HttpClient, private userSettingsService: UserSettingsService) {
    this.subscription.add(this.userSettingsService.fingerabdruckDevice$.subscribe(fingerabdruckDevice => this.lastUsedDevice = fingerabdruckDevice));
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  getFingerabdruckDevices(): Observable<ValueListItem[]> {
    const ret: BehaviorSubject<ValueListItem[]> = new BehaviorSubject<ValueListItem[]>([]);

    for (const fingerabdruckDevice of this.fingerabdruckDevices) {
      ret.getValue().push({
        key: fingerabdruckDevice,
        value: fingerabdruckDevice
      });
    }

    return ret;
  }

  fetchFingerabdruckDevices(): Observable<any> {
    const ret: Observable<any> = this.http
    .get<string[]>(REST_BIOMETRIE_URL + '/fingerprint/device-names').pipe(
      tap((result) => {
        for (const singleResultKey of result) {
          this.fingerabdruckDevices.push(singleResultKey);
        }
      }));
    return ret;
  }

  captureFingerabdruecke(deviceName: string, geschlecht: string, geburtsdatum: string): Observable<any> {
    const apiUrl = REST_BIOMETRIE_URL + '/fingerprint/devices/' + encodeURIComponent(deviceName) + '/capture';
    return this.http.post(apiUrl, {
        geschlecht: geschlecht,
        geburtsdatum: geburtsdatum
      },
      {
        observe: 'body',
        responseType: 'blob'
      }
    );
  }

  findInitialDevice(): string {
    if (this.lastUsedDevice && this.hasDeviceInList()) {
      return this.lastUsedDevice;
    } else if (this.fingerabdruckDevices.length > 0) {
      return this.fingerabdruckDevices[0];
    } else {
      return undefined;
    }
  }

  public changeLastUsedDevice(device: string): void {
    this.userSettingsService.saveUserSettings({ fingerabdruckDevice: device });
  }

  private hasDeviceInList(): boolean {
    return this.fingerabdruckDevices.includes(this.lastUsedDevice);
  }

}
